// 发布目录
export const PUBLIC_PATH_URI = '/reserve/'
export const PUBLIC_PATH = process.env.NODE_ENV === 'production' ? PUBLIC_PATH_URI : '/'
